import { SortTypeEnum } from "@repo/helpers";

export interface IColumn<T> {
	name: string;
	value?: string | Element | Function;
	propertyName?: keyof T;
	clientTemplate?: string;
	sortBy: SortTypeEnum;
	sortable?: boolean;
	getValue: (o: T) => any;
}

export class Column<TObj> implements IColumn<TObj> {
	public name: string;
	public propertyName?: keyof TObj & string;
	public sortBy: SortTypeEnum;
	public displayFunction?: (i: any) => any;
	public sortable?: boolean;
	public value?: any;
	public width?: string;
	public minWidth?: number;
	/* For templates/display functions, in case need access to other props */
	public useFullObject?: boolean;
	//to remove
	public clientTemplate?: string;
	public visible: boolean;
	public charLimit: number;
	/* For columns that also act as hyperlinks */
	public linkUrl?: string;

	constructor(
		name: string,
		propertyName?: keyof TObj & string,
		sortBy: SortTypeEnum = SortTypeEnum.none,
		value?: any,
		sortable = true,
	) {
		this.name = name;
		this.propertyName = propertyName;
		this.sortBy = sortBy;
		this.value = value;
		this.sortable = sortable;
		this.visible = true;
	}

	public withSortBy(sortBy: SortTypeEnum) {
		this.sortBy = sortBy;
		return this;
	}

	public clearFormat() {
		this.displayFunction = undefined;
		return this;
	}

	public withFormat(displayFunction?: (i: any) => any) {
		if (this.displayFunction) {
			const oldFn = this.displayFunction;
			this.displayFunction = (o: any) => displayFunction(oldFn(o));
		} else this.displayFunction = displayFunction;
		return this;
	}

	public withValue(value: any) {
		this.value = value;
		return this;
	}

	public getValue(o: TObj) {
		let value: any = this.value || o;
		if (this.propertyName) {
			value = o[this.propertyName];
		}
		if (this.clientTemplate) {
			const regexMatch = /# ?(\w+) ?#/g;
			const matches = this.clientTemplate.matchAll(regexMatch);
			const properties = [];
			let currentMatch = matches.next();
			while (!currentMatch.done) {
				properties.push(currentMatch.value[1]);
				currentMatch = matches.next();
			}
			const stringReplace = new RegExp(regexMatch, "");
			let stringValue = "" + this.clientTemplate;
			for (const i in properties) {
				stringValue = stringValue.replace(stringReplace, value[properties[i]] || "");
			}
			value = stringValue;
		}
		if (this.displayFunction) {
			value = this.displayFunction(this.useFullObject ? o : value);
		}
		return value;
	}

	public withSortable(sortable: boolean) {
		this.sortable = sortable;
		return this;
	}

	public withMinWidth(pixels: number) {
		this.minWidth = pixels;
		return this;
	}

	public withVisibility(visible: boolean) {
		this.visible = visible;
		return this;
	}

	public withCharLimit(charLimit: number) {
		this.charLimit = charLimit;
		return this;
	}

	public withTemplate(template: string) {
		this.clientTemplate = template;
		return this;
	}

	public withFullObject(useFullObject: boolean = true) {
		this.useFullObject = useFullObject;
		return this;
	}

	public asLink(url: string) {
		this.linkUrl = url;
		return this;
	}
}
